module.exports = __webpack_public_path__ + "static/media/image1@2x.4e707a28.png";